import React, { useCallback, useState } from 'react';
const DndSortable = ({ onDragOver, onDragEnd, onDrop, children })=>{
    const [draggedElement, setDraggedElement] = useState(null);
    const onDragBegin = useCallback((id, position)=>{
        setDraggedElement({
            id,
            initialPosition: position
        });
    }, []);
    const onDragEndHandler = ()=>{
        if (draggedElement && onDragEnd) {
            onDragEnd(draggedElement.id, draggedElement.initialPosition);
        }
        setDraggedElement(null);
    };
    const onDropHandler = useCallback((position)=>{
        if (draggedElement !== null && position !== null && draggedElement.initialPosition !== position) {
            onDrop && onDrop(draggedElement.id, position);
        }
    }, [
        draggedElement,
        onDrop
    ]);
    const onHoverHandler = useCallback((position)=>{
        if (draggedElement !== null) {
            onDragOver && onDragOver(draggedElement.id, position, draggedElement.initialPosition);
        }
    }, [
        draggedElement,
        onDragOver
    ]);
    return children({
        onDragBegin,
        onDragEnd: onDragEndHandler,
        onHover: onHoverHandler,
        onDrop: onDropHandler,
        draggedElementId: draggedElement ? draggedElement.id : null
    });
};
DndSortable.displayName = 'DndSortable';
export default DndSortable;

//# sourceMappingURL=DndSortable.js.map